module.exports = __webpack_public_path__ + "img/icon-card-trans.1a938175.svg";